import { updateMark } from 'tiptap-commands'
import { Mark } from 'tiptap'

export default class Align extends Mark {
  get name() {
    return 'align'
  }

  get defaultOptions() {
    return {
      textAlign: ['left', 'center', 'right'],
    }
  }

  get schema() {
    return {
      attrs: {
        textAlign: {
          default: 'left',
        },
      },
      content: 'inline*',
      defining: true,
      draggable: false,
      parseDOM: this.options.textAlign.map((align) => ({
        tag: `span[class="ql-align-${align}"]`,
        attrs: { textAlign: align },
      })),
      toDOM: (node) => ['span', { class: `ql-align-${node.attrs.textAlign}` }, 0],
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch, view) => {
      return updateMark(type, attrs)(state, dispatch, view)
    }
  }
}
